import content from '../generated/content.json';

export const publicTalks = content.publicTalks.talks;
